import script from "./Program.vue?vue&type=script&lang=ts&setup=true"
export * from "./Program.vue?vue&type=script&lang=ts&setup=true"

import "./Program.vue?vue&type=style&index=0&id=7e4415c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e4415c2"]])

export default __exports__